(() => {
  'use strict';

  if (window.__FTRFixedBundleSubscriptionPriceSyncV3Installed) return;
  window.__FTRFixedBundleSubscriptionPriceSyncV3Installed = true;

  let refreshTimer = null;

  function getWrappers() {
    return Array.from(document.querySelectorAll('[data-fixed-bundle-loop]'));
  }

  function asNumber(value) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function selectedPlan(wrapper) {
    const state = window.FTRLoopBundle;
    const select = wrapper.querySelector('.loop-purchase-option__frequency select');
    const selectedOption = select?.selectedOptions?.[0];
    const selectedShopifyId = String(
      selectedOption?.dataset?.shopifySellingPlanId || state?.selectedSellingPlanShopifyId || ''
    ).split('/').pop();

    if (selectedShopifyId && Array.isArray(state?.sellingPlans)) {
      const matched = state.sellingPlans.find((plan) => {
        const id = String(
          plan?.adminGraphQlApiId || plan?.shopifyId || plan?.sellingPlanId || plan?.id || ''
        ).split('/').pop();
        return id === selectedShopifyId;
      });
      if (matched) return matched;
    }

    const optionIndex = asNumber(select?.value);
    if (optionIndex != null && state?.sellingPlans?.[optionIndex]) return state.sellingPlans[optionIndex];
    return state?.selectedSellingPlan || state?.sellingPlans?.[0] || null;
  }

  function discountPercentage(plan) {
    if (!plan) return 0;
    const policies = Array.isArray(plan.pricingPolicies) ? plan.pricingPolicies : [];
    for (const policy of policies) {
      const type = String(policy?.adjustmentType || policy?.adjustment_type || '').toUpperCase();
      const values = [
        policy?.adjustmentValue?.percentage,
        policy?.adjustment_value?.percentage,
        policy?.percentage,
        type.includes('PERCENT') ? policy?.adjustmentValue : null
      ];
      for (const value of values) {
        const parsed = asNumber(value);
        if (parsed != null && parsed > 0 && parsed <= 100) return parsed;
      }
    }

    const values = [
      plan?.discountPercentage,
      plan?.discount?.percentage,
      plan?.discountValue,
      plan?.percentage,
      plan?.priceAdjustment?.percentage,
      plan?.price_adjustment?.percentage
    ];
    for (const value of values) {
      const parsed = asNumber(value);
      if (parsed != null && parsed > 0 && parsed <= 100) return parsed;
    }
    return 0;
  }

  function currencyCode(wrapper) {
    const state = window.FTRLoopBundle;
    return state?.bundleDetails?.currencyCode || state?.bundleDetails?.data?.currencyCode ||
      wrapper?.dataset?.currency || document.documentElement.dataset.currency || 'USD';
  }

  function formatMoney(cents, wrapper) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currencyCode(wrapper)
      }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function syncWrapper(wrapper) {
    const state = window.FTRLoopBundle;
    if (!wrapper || !state) return;

    const checkedType = wrapper.querySelector('.loop-purchase-options input[type="radio"]:checked')?.value;
    const purchaseType = checkedType || state.purchaseType || 'one-time';
    const oneTimePrice = asNumber(wrapper.dataset.oneTimePrice);
    if (oneTimePrice == null || oneTimePrice <= 0) return;

    const plan = selectedPlan(wrapper);
    const percentage = purchaseType === 'subscription' ? discountPercentage(plan) : 0;
    const visualPrice = purchaseType === 'subscription' && percentage > 0
      ? Math.round(oneTimePrice * (1 - percentage / 100)) : oneTimePrice;

    const subscriptionPrice = wrapper.querySelector('[data-loop-subscription-price]');
    if (subscriptionPrice) {
      subscriptionPrice.textContent = formatMoney(visualPrice, wrapper);
      subscriptionPrice.dataset.currentPrice = String(visualPrice);
    }

    // Fixed-bundle visual only: show the saving for the currently selected plan.
    // Support both the class requested by the UI and the existing data hook.
    const badges = wrapper.querySelectorAll('.loop-purchase-option__save-badge, [data-loop-save-badge]');
    badges.forEach((badge) => {
      if (percentage > 0) {
        badge.hidden = false;
        badge.textContent = `Save ${percentage}%`;
      } else {
        badge.hidden = true;
        badge.textContent = '';
      }
    });
  }

  function syncAll() {
    getWrappers().forEach(syncWrapper);
  }

  function scheduleSync() {
    syncAll();
    requestAnimationFrame(syncAll);
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(syncAll, 50);
  }

  document.addEventListener('ftr:loop:selling-plan-change', scheduleSync);
  document.addEventListener('change', (event) => {
    if (event.target.closest('[data-fixed-bundle-loop]')) scheduleSync();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-fixed-bundle-loop]')) scheduleSync();
  });
  document.addEventListener('shopify:section:load', scheduleSync);

  function init() {
    if (!getWrappers().length) return;
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
